import { IBackofficeCompany } from 'types/backoffice.types';
import { IUserIdentity } from '../../../types/auth.types';
import { ICompany } from '../../../types/company.types';
import { IRole } from '../../../types/roles.types';

/**
 * Module types for the Create Role component
 */
export enum EModule {
  GENERAL = 'Company Management',
  LIBRARY = 'Library',
  ASSESSMENTS = 'Assessment',
  SPEECH_SENSE = 'Speech Sense',
  CONTESTS = 'Contest',
  INTERVIEWS = 'Interview',
}

export enum EPrivilege {
  MANAGE_ASSESSMENTS = 'manage_assessments',
  INVITATION = 'invitation',
  REPORTING = 'reporting',
  MANAGE_USER = 'manage_user',
  DEFAULT = 'default',
  MANAGE_LIBRARY = 'manage_library',
  MANAGE_SETTINGS = 'manage_settings',
  MANAGE_CONTEST = 'manage_contest',
  MANAGE_PROBLEM = 'manage_problems',
}

/**
 * Access level types
 */
export enum EAccessLevel {
  NO_VIEW = 'No View',
  VIEW_ONLY = 'View Only',
  EDIT = 'Edit',
}

export type TPrivilegeMapper = {
  [key in EModule]?: Record<EPrivilege, EAccessLevel>;
};

/**
 * Props for the CreateRole component
 */
export interface ICreateRoleProps {
  /**
   * Callback when role is saved
   * @param roleName - Name of the new role
   * @param selectedModules - Array of selected modules with privileges
   */
  onSave: () => void;

  /**
   * Callback when cancel is clicked
   */
  onCancel: () => void;
  userIdentityData: IUserIdentity | null;
  company: ICompany | IBackofficeCompany | null | undefined;
  editMode?: boolean;
  roleToEdit?: IRole | null;
  companySlug?: string;
  isBackOfficePage?: boolean;
}

/**
 * Privilege category type
 */
export interface IPrivilegeCategory {
  name: string;
  privileges: TPrivilege[];
  accessLevel?: EAccessLevel[];
  defaultAccess?: EAccessLevel;
  alias: EPrivilege;
}

/**
 * Privilege type
 */
export type TPrivilege = {
  id: string;
  name: string;
};

/**
 * Module configuration type
 */
export interface IModuleConfig {
  id: string;
  name: string;
  category: string;
  access: EAccessLevel[];
  defaultAccess: EAccessLevel;
  categoryData: IPrivilegeCategory[];
}
